import React from "react";

const GolfCourseAgreement = () => {
  return (
    <div>
      <h1>REGLAMENTO DE GOLF</h1>

      <h2>1. INTRODUCCIÓN</h2>

      <p>
        Este reglamento establece las normas para el uso del campo de golf, así
        como la vestimenta apropiada para el uso de la mesa de práctica y campo
        de golf, la organización de grupos, el ritmo de juego, el uso del
        servicio de caddies y el uso de carros de golf.
      </p>

      <p>
        Este reglamento también define las sanciones por el incumplimiento a las
        disposiciones establecidas en el mismo.
      </p>

      <p>
        El propósito es impulsar el orden en nuestro campo de golf y sus
        instalaciones, así como preservar la tradición, orden y respeto entre
        los socios.
      </p>

      <p>
        El presente reglamento refiere a “jugador”, “socio”, “juniors”,
        “juveniles e infantiles” e “invitados”, tanto hombres como mujeres y
        será aplicable para todos ellos.
      </p>

      <h2>2. CÓDIGO DE VESTIMENTA</h2>

      <p>
        El código de vestimenta promueve la funcionalidad y la conservación de
        los estándares de conducta que fomentan el prestigio y la tradición de
        nuestro Club. Este código aplica para socios y sus invitados.
      </p>

      <h3>2.1 Vestimenta en campo de golf (campo largo y campo corto)</h3>

      <h3>Caballeros</h3>

      <table>
        <thead>
          <tr>
            <th>PERMITIDO</th>
            <th>NO PERMITIDO</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              Camisa tipo polo con cuello y mangas (incluye cuello tipo mock).
              Pantalón clásico o de golf. Gorra correctamente colocada y zapatos
              de golf o tenis.
            </td>
            <td>
              Pantalones cargo, pants, jeans, camisas sin cuello o sin mangas.
            </td>
          </tr>
        </tbody>
      </table>

      <h3>Damas</h3>

      <table>
        <thead>
          <tr>
            <th>PERMITIDO</th>
            <th>NO PERMITIDO</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              Camisa con cuello y mangas, sin mangas con cuello o con mangas sin
              cuello. Pantalón, bermudas, faldas o vestidos de golf (no
              demasiado cortos).
            </td>
            <td>
              Tirantes, espalda escotada, escotes reveladores, shorts, camisetas
              sin cuello, jeans, leggings, pants.
            </td>
          </tr>
        </tbody>
      </table>

      <h3>2.2 Vestimenta en Área de Práctica y Putting Green</h3>

      <p>
        Se aplican las mismas reglas que en el campo de golf, con la única
        diferencia que los caballeros pueden usar bermudas de corte clásico y
        pants; y las mujeres pants.
      </p>

      <h2>3. USO DEL CAMPO</h2>

      <h3>3.1 Grupos</h3>

      <p>
        Los criterios de conformación de grupos que se indica a continuación
        tienen como propósito dar fluidez al juego y los aplicará el starter.
      </p>
      <table>
        <tr>
          <td>
            <strong>Lunes a viernes</strong>
          </td>
          <td>
            <ul>
              <li>Permitido grupos de 1 a 5 personas</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td>
            <strong>Sábados</strong>
          </td>
          <td>
            <ul>
              <li>Permitido grupos de 4 y 5 personas</li>
              <li>
                Grupos de 1, 2 y 3 personas permitidos desde las 13:00 hrs o
                antes de las 7:00 hrs (9 hoyos)
              </li>
            </ul>
          </td>
        </tr>
        <tr>
          <td>
            <strong>Domingos y días festivos</strong>
          </td>
          <td>
            <ul>
              <li>Permitido grupos de 4 y 5 personas</li>
              <li>
                Grupos de 1, 2 y 3 personas permitidos desde las 12:30 hrs o
                antes de las 7:00 hrs (9 hoyos)
              </li>
            </ul>
          </td>
        </tr>
      </table>
      <ul>
        <li>
          El starter siempre dará preferencia de salida a grupos de 4 y 5
          jugadores.
        </li>

        <li>1 solo jugador o 2 no tendrán derecho a pedir el paso.</li>

        <li>
          El starter promoverá la conformación de grupos de jugadores para
          permitir su salida al campo.
        </li>

        <li>
          En ningún momento podrán jugar grupos mayores a 5 jugadores. El Comité
          de Golf podrá aplicar excepciones en eventos autorizados previamente.
        </li>
      </ul>
      <h3>3.2 Ingreso al campo</h3>

      <p>
        Todo jugador (socio o invitado) deberá contar con hándicap registrado en
        el sistema GHIN, de no tenerlo deberán aprobar una prueba de aptitud con
        los profesionales del Club, previo a su salida al campo.
      </p>

      <p>Podrán ingresar:</p>

      <ul>
        <li>Los socios mayores de 18 años.</li>
        <li>
          Los invitados de los socios mayores de 18 años que cumplan con los
          requisitos señalados en este reglamento, previa entrega, sin
          excepción, de su green fee o pase al starter antes de empezar a jugar.
        </li>
        <li>
          Las personas o grupos expresamente autorizados por el Consejo de
          Administración, el Comité de Golf o la Dirección General.
        </li>
        <li>
          Aquellos juveniles - infantiles e invitados (menores de 18 años)
          autorizados por la Academia de Golf del Club y con la licencia
          apropiada para salir al campo.
        </li>
        <li>
          Los invitados de juveniles (tanto el socio como el invitado deberán
          estar entre el rango de 18 a 29 años).
        </li>
        <li>
          Todos los invitados sin importar edad o hándicap deberán llevar caddie
          (a excepción de infantiles y juveniles de la GIRA).
        </li>
      </ul>

      <h3>3.3 Salidas al campo</h3>

      <p>
        Todo jugador deberá solicitar su salida en la página de reservaciones
        del Club: <a href="https://cccm.teetapp.mx">https://cccm.teetapp.mx</a>
      </p>

      <p>
        El sistema de salidas será determinado por el Consejo de Administración
        y modificado o adecuado cuando lo estime necesario.
      </p>

      <p>Es obligación de todo jugador conocer las Reglas de Golf.</p>

      <p>
        Únicamente los jugadores de golf podrán ingresar al campo y no podrán
        llevar acompañantes no golfistas.En el caso de torneos o circunstancias
        especiales que se permitan acompañantes como galería, éstos se harán
        responsables de su seguridad y comportamiento.
      </p>

      <p>
        La práctica de caminata, jogging o cualquier otra actividad diferente a
        la práctica del golf está permitida en el campo de golf única y
        exclusivamente dentro de los horarios y días establecidos por el
        Consejo.
      </p>
      <ul>
        <li>Lunes a viernes hasta las 10:00 hrs</li>
        <li>Sábados y domingos hasta las 08:00 hrs</li>
        <li>Por las tardes a partir de las 17:00 hrs</li>
      </ul>

      <p>
        Los jugadores que no tengan hándicap deberán solicitar autorización al
        Director de Golf, o a quien éste autorice, para salir a jugar al campo.
        El uso de un caddie es obligatorio para estos jugadores.
      </p>

      <p>
        Los jugadores o grupos de jugadores forzosamente deberán iniciar su
        juego por las mesas de salida de los hoyos 1 y 10. Todos los jugadores o
        grupos de jugadores deberán seguir el orden numérico progresivo de los
        hoyos. El starter podrá, a discreción, autorizar grupos a salir en
        diferentes hoyos del campo, si la circunstancia así lo amerita.
      </p>

      <h3>Horarios de salidas al campo</h3>
      <ul>
        <li>
          <strong>Verano:</strong> 06:50 - 15:05 hrs
        </li>
        <li>
          <strong>Invierno:</strong> 07:00 - 15:05 hrs
        </li>
      </ul>

      <p>
        El Comité de Golf podrá mover estos horarios dependiendo de la temporada
        del año, previa notificación a los socios. Para las salidas después de
        este horario, el registro será directo con el starter.
      </p>

      <h2>4. ÁREA DE PRÁCTICA</h2>

      <p>
        Las áreas de práctica comprenden la plataforma, el chipping green, el
        putting green, la trampa de arena y la zona adyacente a los hoyos cortos
        (práctica de approach).
      </p>

      <p>
        <strong>Horario de uso:</strong> 06:00 a 18:00 horas, de lunes a
        domingo.
      </p>

      <p>Normas de uso obligatorio:</p>

      <ul>
        <li>
          Los menores de 7 años deberán estar en todo momento bajo la
          supervisión directa de un adulto responsable.
        </li>
        <li>
          Las bolas de práctica son propiedad del Club. No tienen costo alguno
          para los socios y su uso se encuentra limitado a las áreas de
          práctica.
        </li>
        <li>Se prohíbe hacer uso de bolas de práctica en el campo de golf.</li>
        <li>
          Los golpes deberán realizarse únicamente desde las zonas delimitadas.
        </li>
        <li>
          El uso de teléfonos móviles deberá limitarse al modo silencioso. En
          caso de realizar o recibir llamadas, deberá retirarse del área de
          práctica.
        </li>
        <li>No se permite reproducir música en altavoz.</li>
        <li>
          <strong>
            Está estrictamente prohibido “volarse” la malla trasera. Cualquier
            persona que incurra en la infracción será sancionada con una
            suspensión temporal de 2 meses.
          </strong>
        </li>
        <li>
          En caso de reincidencia, el Consejo de Administración evaluará la
          sanción correspondiente.
        </li>
      </ul>
      <h2>5. SALIDAS FIJAS</h2>

      <h3>5.1 Definición:</h3>

      <p>
        Es un derecho adquirido que corresponde a los socios que por su
        antigüedad y constancia se les ha otorgado y han mantenido su grupo
        desde que se implementó este sistema, establece horarios fijos de salida
        en fines de semana y miércoles, para todos aquellos grupos que
        acostumbran jugar en el mismo horario.
      </p>

      <h3>5.2 Objetivo:</h3>

      <p>
        Reconocer a aquellos socios que, por su antigüedad y constancia de juego
        en un mismo horario, no requieren reservar una salida, pero sí tienen la
        obligación de cumplir con las reglas que aplican a las salidas fijas,
        con la finalidad de optimizar el orden, aprovechamiento y el control de
        las salidas en horas pico.
      </p>

      <h3>5.3 Horario continuo de salidas fijas:</h3>

      <p>
        Estas salidas se darán en intervalos de 9 minutos, formando un total de
        36 salidas fijas por día.
      </p>

      <table>
        <thead>
          <tr>
            <th>DÍAS</th>
            <th>SOCIOS</th>
            <th>HORARIOS</th>
            <th>TEE</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Sábados</td>
            <td>Caballeros</td>
            <td>06:50 – 09:05 horas</td>
            <td>Hoyo 1</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td>06:50 – 09:14 horas</td>
            <td>Hoyo 10</td>
          </tr>
          <tr>
            <td>Domingos</td>
            <td>Caballeros</td>
            <td>06:50 – 09:05 horas</td>
            <td>Por ambos Tees</td>
          </tr>
          <tr>
            <td>Miércoles</td>
            <td>Damas</td>
            <td>07:53 – 09:05 horas</td>
            <td>Hoyo 1</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td>08:02 – 08:56 horas</td>
            <td>Hoyo 10</td>
          </tr>
        </tbody>
      </table>

      <h2>6. REGLAS PARA SALIDAS FIJAS</h2>
      <ol>
        <li>
          Cada grupo con salida fija deberá estar conformado por un mínimo de
          seis (6) y un máximo de ocho (8) jugadores registrados. Ningún jugador
          podrá pertenecer a 2 grupos con salida fija el mismo día, salvo
          aquellos que integren grupos con doble salida.
        </li>

        <li>
          Cada grupo deberá designar un Capitán y un Subcapitán, quienes serán
          responsables de la gestión, comunicación y cancelación de la salida en
          caso de no utilizarse. En situaciones extraordinarias, cualquier
          integrante registrado podrá realizar la cancelación directamente con
          la Academia de Golf.
        </li>

        <li>
          <p>
            Todas las salidas fijas serán monitoreadas cada semana. Para
            conservar el derecho a la salida fija, el grupo deberá utilizarla al
            menos en 22 ocasiones durante cada año calendario.
          </p>
          <p>
            <b>
              Se considerará como asistencia cuando al menos dos (2) integrantes
              del grupo jueguen en el horario asignado.
            </b>
          </p>
          <p>
            El resultado del monitoreo semanal será publicado mensualmente y de
            manera clara en la forma que determine el Comité de Golf. Es
            responsabilidad de los Capitanes, Co capitanes y Jugadores, que
            pertenezcan a un grupo con salida fija, mantenerse informados sobre
            la situación de su grupo en cuanto asistencia y cancelaciones.
          </p>
          <p>
            En el caso de resultar que un grupo no cumplió con el mínimo de
            asistencias requeridas, de conformidad con lo antes establecido, el
            Comité de Golf enviará la información correspondiente a la Dirección
            General para una segunda revisión. Una vez confirmado el
            incumplimiento se notificará al Comité Ejecutivo para que verifique
            y, en su caso, una vez hecho del conocimiento del Consejo de
            Administración, se proceda a notificar por escrito al Capitán del
            grupo, la pérdida permanente del derecho a la salida fija,
            adjuntando la relación de asistencias y/o faltas correspondientes.
          </p>
        </li>

        <li>
          Los Capitanes y Subcapitanes no están obligados a confirmar su salida
          cada fin de semana, ya que está se encuentra reservada de forma
          permanente en la plataforma de reservaciones.
        </li>

        <li>
          El Capitán podrá realizar hasta tres (3) cambios en la conformación
          del grupo durante el año en curso.
        </li>
      </ol>

      <p>
        Los grupos con salida fija deberán aceptar a socios en lista de espera
        el mismo día, siempre que haya espacios disponibles.
      </p>

      <p>
        Para conservar el derecho a la salida fija, los grupos deberán cumplir
        con los siguientes requisitos:
      </p>

      <p>
        1.- Asistencia mínima (22 veces en un mismo año calendario) conforme a
        lo establecido en el artículo 6.3.
      </p>

      <p>
        2.- Cancelación oportuna de sus salidas, de acuerdo con lo dispuesto en
        el artículo 7.
      </p>

      <h2>7. CANCELACIONES</h2>

      <p>
        <b>Fines de semana:</b> Deberán realizarse en el sitio{" "}
        <a href="https://cccm.teetapp.mx">https://cccm.teetapp.mx</a>, a más
        tardar a las 11:00 horas del viernes previo.
      </p>

      <p>
        <b>Miércoles:</b> Las cancelaciones deberán efectuarse en el mismo sitio
        a más tardar a las 09:00 horas del día anterior.
      </p>

      <strong>
        La obligación de cancelar se mantiene vigente durante todo el año, con
        excepción de cuando se realicen torneos internos o se preste el campo
        para eventos.
      </strong>

      <ol>
        <li>
          Al cancelar una salida fija, esta se libera automáticamente en la
          plataforma de reservaciones, quedando disponible para cualquier socio
          que no pertenezca a un grupo con salida fija.
        </li>

        <li>
          <p>
            Se considerará <b>infracción</b> cuando un grupo con salida fija no
            se presente sin haber cancelado previamente. El grupo con salida
            fija que acumule{" "}
            <b>cuatro (4) infracciones en el mismo año calendario</b>, perderá
            permanentemente el derecho a la salida fija.
          </p>
          <p>
            Todas las salidas fijas serán monitoreadas cada semana y el
            resultado del monitoreo semanal será publicado mensualmente y de
            manera clara en la forma que determine el Comité de Golf.
          </p>
          <p>
            <strong>
              Es responsabilidad de los Capitanes, Cocapitanes y Jugadores que
              pertenezcan a un grupo con salida fija, mantenerse informados
              sobre la situación de su grupo en cuanto asistencia y
              cancelaciones.
            </strong>
          </p>
          <p>
            En el supuesto de que algún grupo acumule cuatro (4) infracciones
            dentro del mismo año calendario, de conformidad con lo establecido
            en este apartado, el Comité de Golf enviará la información
            correspondiente a la Dirección General para una segunda revisión.
            Una vez confirmado el incumplimiento, se notificará al Comité
            Ejecutivo para que, con el conocimiento del Consejo de
            Administración, se proceda a notificar por escrito al Capitán del
            grupo, la <b>pérdida permanente del derecho a la salida fija,</b>{" "}
            adjuntando la relación de infracciones correspondientes.
          </p>
        </li>

        <li>
          Las infracciones acumuladas se eliminan al finalizar cada año
          calendario.
        </li>

        <li>No se asignarán nuevas salidas fijas a ningún grupo ni jugador.</li>
      </ol>

      <h2>8. RITMO DE JUEGO</h2>

      <ol>
        <li>
          El tiempo para una ronda de golf deberá ser de 4 horas con 50 minutos,
          más 17 minutos de snack, para un total de 5 horas con 7 minutos.
        </li>

        <li>
          En caso de que un grupo se encuentre fuera de tiempo y posición, el
          Marshall tendrá la facultad de intervenir para que se retome el ritmo
          adecuado de juego. Las acciones que podrá tomar incluyen, entre otras:
          <ul>
            <li>Solicitar que los jugadores apresuren el paso.</li>
            <li>
              Indicar que levanten la bola y avancen directamente al siguiente
              hoyo.
            </li>
            <li>
              Separar al grupo si es necesario para mejorar el flujo del juego.
            </li>
          </ul>
          <p>
            Estas medidas buscan asegurar una experiencia fluida y justa para
            todos los participantes en el campo.
          </p>
        </li>

        <li>
          <p>
            Es obligación de todos los jugadores obedecer las indicaciones del
            Marshall, de lo contrario los jugadores serán reportados y
            sancionados.
          </p>

          <p>Es aconsejable que todos los jugadores jueguen “Ready Golf”.</p>
        </li>
      </ol>

      <h2>9. RESERVACIONES</h2>

      <p>
        Todas las reservaciones para salir al campo largo deberán hacerse
        individualmente en la página:{" "}
        <a href="https://cccm.teetapp.mx">https://cccm.teetapp.mx</a> y estarán
        sujetas a las siguientes disposiciones:
      </p>
      <ol>
        <li>Toda reserva podrá hacerse hasta con 8 días de anticipación.</li>

        <li>
          En la aplicación se deberán anotar los nombres de todos los jugadores
          que integrarán el grupo, así como el día que desean jugar en los
          horarios que aparecen libres.
        </li>

        <li>
          Las reservaciones podrán hacerse de lunes a domingo en un horario de
          06:50 a 15:05 horas. Cualquier jugador que desee salir al campo largo
          en otro horario, deberá solicitar autorización en la caseta del
          starter.
        </li>

        <li>
          Únicamente la persona que realizó la reservación podrá cancelarla. La
          cancelación deberá efectuarse con un mínimo de 24 horas de
          anticipación a la hora de salida reservada, salvo lo aplicable a las
          Salidas Fijas referido en el punto 5 de este Reglamento.
        </li>

        <li>
          Los jugadores que no se presenten a jugar en el horario reservado y no
          hayan cancelado previamente su salida en tiempo y forma, acumularán
          una <b>falta</b>. Al llegar a ocho (8) faltas dentro de un mismo año
          calendario, se suspenderá su derecho a realizar reservaciones por un
          periodo de tres meses.
        </li>
      </ol>

      <p>
        <strong>
          El Comité de Golf enviará la información correspondiente a la
          Dirección General y una vez confirmado el incumplimiento, se
          notificará al jugador la pérdida del derecho a reservar su salida por
          un período de 3 meses.
        </strong>
      </p>

      <h2>10. CADDIES</h2>
      <ol>
        <li>
          <b>Autoridad y cumplimiento</b>
          <p>
            El starter y cualquier profesional de golf están facultados para
            negar la salida a los jugadores que no acaten el reglamento y/o, en
            su caso, levantar el reporte correspondiente.
          </p>
        </li>
        <li>
          <b>Obligaciones del jugador al contratar un caddie</b>
          <p>
            El socio deberá tratar al caddie con respeto y cortesía en todo
            momento. Asimismo, estará obligado a cubrir la cuota mínima
            establecida por el Club al terminar la ronda. Si el jugador desea
            otorgar un pago adicional, podrá hacerlo a su entera discreción.
          </p>
          <p>
            El socio será responsable de instruir y supervisar adecuadamente el
            trabajo del caddie durante la ronda de golf, asegurándose de que los
            divots y las trampas queden debidamente arreglados.
          </p>
        </li>
        <li>
          <b>Asignación de caddies por grupo</b>
          <p>
            Con el objetivo de conservar el campo en óptimas condiciones,
            mantener el ritmo de juego y apoyar a los caddies, se establece la
            siguiente distribución mínima de caddies por grupo:
          </p>
          <table>
            <thead>
              <tr>
                <th>TAMAÑO DEL GRUPO</th>
                <th>MÍNIMO DE CADDIES</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Onesome</td>
                <td>1 Caddie</td>
              </tr>
              <tr>
                <td>Twosome</td>
                <td>1 Caddie</td>
              </tr>
              <tr>
                <td>Threesome</td>
                <td>1 Caddie</td>
              </tr>
              <tr>
                <td>Foursome</td>
                <td>2 Caddies</td>
              </tr>
              <tr>
                <td>Fivesome</td>
                <td>3 Caddies</td>
              </tr>
            </tbody>
          </table>

          <p>
            Todos los invitados están obligados a llevar caddie sin importar la
            edad.
          </p>
        </li>
        <li>
          <b>Excepción para uso de caddies</b>
          <ol>
            <li>
              Infantiles y juveniles que juegan la Gira Juvenil autorizados por
              la Academia de Golf.
            </li>

            <li>Profesionales del Club, instructores, asistentes y caddies.</li>

            <li>Superintendente de campo y auxiliares de campo.</li>

            <li>
              Los jugadores menores de 18 años categoría campeonato y AA, socios
              juniors (entre 18 y 26 años) con hándicap menor a 18, de la
              siguiente manera:
            </li>

            <li>
              Onesomes y Twosomes: exentos de caddie. • Threesomes, Foursomes y
              Fivesomes: mínimo 1 caddie.
            </li>
          </ol>
        </li>
        <li>
          <b>Responsabilidad en el cuidado del campo</b>
          <p>
            El starter y cualquier profesional de golf están facultados para
            negar la salida a los jugadores que no acaten el reglamento y/o, en
            su caso, levantar el reporte correspondiente.
          </p>
        </li>

        <li>
          <b>Sanciones</b>
          <p>
            El starter y cualquier profesional de golf están facultados para
            negar la salida a los jugadores que no acaten el reglamento y/o, en
            su caso, levantar el reporte correspondiente.
          </p>
        </li>
      </ol>

      <h2>11. USO DE CARRITOS DE GOLF</h2>

      <ol>
        <li>
          Para ingresar un carrito de golf al Club, si hay disponibilidad de
          espacio, el socio deberá cubrir la cuota de registro correspondiente
          que fije anualmente el Consejo de Administración, así como el monto
          mensual correspondiente al estacionamiento y carga de éste.
        </li>

        <li>
          El derecho de usar el espacio es intransferible. La edad mínima para
          usar un carrito de golf dentro de las instalaciones es de 15 años, ya
          sea propio o rentado.
        </li>

        <li>
          <p>
            El tránsito de los carros se determinará dependiendo de la temporada
            y del daño ocasionado por las lluvias.
          </p>

          <table>
            <thead>
              <tr>
                <th>Condición del campo</th>
                <th>Zonas permitidas para circulación</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Nivel 5 (saturado)</td>
                <td>Solo caminos</td>
              </tr>
              <tr>
                <td>Nivel 4 (muy delicado)</td>
                <td>Caminos y 90° al rough</td>
              </tr>
              <tr>
                <td>Nivel 3 (delicado)</td>
                <td>Caminos y rough</td>
              </tr>
              <tr>
                <td>Nivel 2 (húmedo)</td>
                <td>Caminos, rough y 90° al fairway</td>
              </tr>
              <tr>
                <td>Nivel 1 (normal)</td>
                <td>Caminos, rough y 90° al fairway</td>
              </tr>
            </tbody>
          </table>
          <br />
          <ul>
            <li>
              Los carros no podrán hacer su recorrido del hoyo a través del
              fairway, en todos los casos deberán entrar al fairway a 90º desde
              los caminos.
            </li>
            <li>
              No podrán acercarse al green a menos de 25 yardas y a 10 yardas de
              las mesas de salida.{" "}
            </li>
            <li>
              En todo momento se deberá respetar la señalización de la
              circulación de los carritos.
            </li>
            <li>
              Las personas sorprendidas infringiendo los puntos anteriores,
              serán acreedoras a la sanción correspondiente.
              <ul>
                <li>
                  En caso de carritos de propietarios: Suspensión del uso de ese
                  carrito por un periodo de 3 meses, sin importar si el carrito
                  fuera prestado.
                </li>

                <li>
                  En caso de carritos de renta del Club: No se le rentará
                  carrito a esa persona por un periodo de 3 meses.
                </li>
              </ul>
            </li>
            <li>
              El Club mantendrá un número de carros para renta disponibles para
              socios e invitados, los cuales tendrán que pagar en la caseta de
              golf la tarifa correspondiente por 9 o 18 hoyos.
            </li>
          </ul>
        </li>

        <li>
          Los carros podrán llevar como máximo 2 (dos) personas. Está prohibido
          llevar pasajeros en la parte trasera del carro. Excepcionalmente se
          podrá llevar un máximo de 3 personas mientras el carro se mantenga
          exclusivamente en los caminos y no ingrese al rough ni al fairway.
        </li>

        <li>
          Todo cambio de carro o retiro temporal (por reparación o salida a otro
          lugar), deberá comunicarse al Comité de Golf, a través de la Dirección
          General.
        </li>

        <li>
          Las llantas de los carritos deberán ser apropiadas y adaptadas para
          las condiciones del campo, según especificaciones vigentes marcadas
          por el Comité de Golf y Campo.
        </li>

        <li>
          <p>
            El Club proporcionará una bandera especial a aquellos jugadores
            <b>mayores de 75 años.</b> Esta bandera será asignada de manera
            personal al jugador, no al carrito, y{" "}
            <b>su uso será exclusivo para la persona autorizada,</b> la bandera
            deberá colocarse en el carrito. Cualquier uso indebido de esta
            bandera —incluyendo su préstamo, transferencia o utilización por
            parte de personas no autorizadas— será sancionado con la suspensión
            del beneficio por un periodo de seis meses.
          </p>

          <p>
            De igual forma se otorgará una bandera a jugadores de cualquier edad
            con alguna justificación médica permanente o temporal, a criterio
            del Comité de Golf.
          </p>

          <p>
            Las banderas azules serán entregadas diariamente a las personas
            debidamente autorizadas en la caseta de golf.
          </p>

          <p>
            <strong>
              Junto con la bandera azul, se proporcionarán las condiciones
              específicas de uso correspondientes al día, las cuales deberán ser
              leídas y respetadas estrictamente por los beneficiarios.
            </strong>
          </p>
        </li>
      </ol>

      <h2>12. HÁNDICAP</h2>
      <ol>
        <li>
          <b>Introducción</b>
          <p>
            El sistema de hándicap es un elemento fundamental del golf, diseñado
            para permitir la competencia equitativa entre jugadores de
            diferentes niveles de habilidad. El CCCM adopta y acata las reglas
            del Sistema de Hándicap de la USGA, el cual establece los
            procedimientos para el cálculo y la gestión del hándicap de cada
            jugador. Estas reglas deben respetarse de la misma manera que las
            Reglas de Golf oficiales, ya que garantizan la transparencia, la
            equidad y la correcta aplicación del hándicap en todas las
            competencias.
          </p>
        </li>
        <li>
          <b>Reglas específicas del Hándicap en el CCCM</b>
          <ol>
            <li>
              <b>Registro de Scores</b>
              <ul>
                <li>
                  Todos los jugadores deberán registrar el score de sus rondas
                  jugadas, sin importar en qué campo jugaron, en el sistema GHIN
                  de la USGA o, en su defecto, entregar la tarjeta de score
                  debidamente llenada y firmada por jugador y testigo en la
                  caseta de golf.
                </li>
                <li>
                  <b>Excepción:</b> Los jugadores que no deseen participar en
                  competencias internas o externas no están obligados a
                  registrar sus scores. Sin embargo, se recomienda el registro
                  para un mejor conocimiento del nivel de juego de cada
                  golfista.
                </li>
              </ul>
              <br />
            </li>
            <li>
              <b>Requisitos de Hándicap para torneos</b>
              <p>
                Para participar en torneos internos organizados por el Club,
                torneos representativos o aquellos organizados por la AGVM y/o
                la FMG, AMFG, los jugadores deberán:
              </p>
              <ul>
                <li>
                  Contar con un hándicap índice activo en el sistema GHIN.
                </li>
                <li>Registrar sus rondas jugadas en el sistema GHIN.</li>
                <li>
                  El Comité de Golf tiene la facultad de requerir un mínimo de
                  tarjetas registradas para la autorización de participación en
                  cualquier torneo.
                </li>
              </ul>
            </li>
          </ol>
          <br />
        </li>
        <li>
          <b>Publicación de Scores</b>
          <p>
            Con el fin de mantener una competencia equitativa, el Comité de Golf
            publicará, a través de los medios a su alcance, los scores
            registrados por los jugadores del CCCM.
          </p>

          <p>
            Esta publicación siempre se realizará en cumplimiento de las Reglas
            del Hándicap de la USGA.
          </p>
        </li>
        <li>
          <b>Veracidad y Cumplimiento</b>
          <p>
            Se espera que todos los jugadores registren sus scores de manera
            fiel y honesta, sin omitir rondas que puedan afectar la correcta
            asignación de su hándicap.
          </p>

          <p>
            Cualquier intento de manipulación del hándicap o de los registros
            será sujeto a revisión y sanción por parte del Comité de Golf o del
            Consejo de Administración.
          </p>

          <p>
            El Comité de Golf se reserva el derecho de ajustar hándicaps en caso
            de detectar inconsistencias o irregularidades.
          </p>

          <p>
            Se podrán aplicar ajustes conforme a las reglas del hándicap si un
            jugador demuestra un desempeño significativamente superior al
            reflejado en su índice.
          </p>
        </li>
      </ol>

      <h1>REGLAMENTO DE GOLFCAMPO CORTO</h1>

      <h2>1. CÓDIGO DE VESTIMENTA</h2>

      <p>El código aplica para socios y sus invitados.</p>

      <table>
        <thead>
          <tr>
            <th></th>
            <th>Permitido</th>
            <th>No Permitido</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <strong>Caballeros</strong>
            </td>
            <td>
              Camisa tipo polo con cuello y mangas (incluye cuello tipo mock).
              Pantalón clásico o de golf. Gorra correctamente colocada y zapato
              de golf o tenis.
            </td>
            <td>
              Pantalones cargo, pants, jeans, camisas sin cuello o sin mangas.
            </td>
          </tr>
          <tr>
            <td>
              <strong>Damas</strong>
            </td>
            <td>
              Camisa con cuello y mangas, sin mangas con cuello o con mangas sin
              cuello. Pantalón, bermudas, faldas o vestidos de golf (no
              demasiado cortos).
            </td>
            <td>
              Tirantes, espaldas escotadas, escotes reveladores, shorts,
              camisetas sin cuello, jeans, leggings, pants.
            </td>
          </tr>
        </tbody>
      </table>

      <h2>2. USO DEL CAMPO CORTO</h2>
      <ol>
        <li>
          <h3>Grupos</h3>
          <p>Todos los días se permiten grupos de 1 a 5 jugadores.</p>
          <ul>
            <li>1 solo jugador o 2 podrán solicitar el paso.</li>

            <li>
              En ningún momento podrán jugar grupos mayores a 5 jugadores. El
              Comité de Golf podrá dar excepciones en eventos autorizados
              previamente.
            </li>
          </ul>
        </li>
        <li>
          <h3>Ingreso al campo</h3>
          <p>
            No es necesario contar con un GHIN para poder ingresar al campo
            corto.
          </p>
          <ul>
            <li>
              Todos los niños menores de 10 años podrán hacer uso del campo y
              deberán salir acompañados de una persona responsable mayor de 18
              años.
            </li>

            <li>
              Los invitados que cumplan con los requisitos señalados en este
              reglamento, previa entrega, sin excepción, de su green fee o pase
              al starter antes de empezar a jugar.
            </li>

            <li>
              Las personas o grupos expresamente autorizados por el Consejo de
              Administración, el Comité de Golf o la Dirección General.
            </li>

            <li>
              Jugadores de nivel principiante que hayan tomado un mínimo de
              cinco clases en la Academia de Golf y cuenten con la autorización
              de los profesionales para su salida.
            </li>
          </ul>
        </li>
        <li>
          <h3>Salidas al campo</h3>
          <ul>
            <li>Deberán realizar su registro con el starter.</li>

            <li>El horario será a partir de las 6:00 a.m. sin reservación.</li>

            <li>Es obligación de todo jugador conocer las Reglas de Golf.</li>

            <li>
              Únicamente los jugadores de golf podrán ingresar al campo y no
              podrán llevar acompañantes no golfistas.
            </li>

            <li>El uso de un caddie no es obligatorio.</li>

            <li>
              Los jugadores o grupos de jugadores forzosamente deberán iniciar
              su juego por la mesa de salida del hoyo 1.
            </li>

            <li>
              La Dirección de Golf podrá hacer uso exclusivo del campo corto
              para la realización de eventos en cualquier momento.
            </li>
          </ul>
        </li>
      </ol>
      <h2>3. SALIDAS FIJAS</h2>
      <p>No hay salidas fijas en el campo corto.</p>
      <h2>4. RITMO DE JUEGO</h2>
      <ol>
        <li>
          El tiempo para una ronda de golf deberá ser de 1 hora con 50 minutos.
        </li>

        <li>
          En caso de que un grupo se encuentre fuera de tiempo y posición, el
          Marshall tendrá la facultad de intervenir para que se retome el ritmo
          adecuado de juego. Las acciones que podrá tomar incluyen, entre otras:
          <ul>
            <li>Solicitar que los jugadores apresuren el paso.</li>
            <li>
              Indicar que levanten la bola y avancen directamente al siguiente
              hoyo.
            </li>
            <li>
              Separar al grupo si es necesario para mejorar el flujo del juego.
            </li>
          </ul>
        </li>

        <li>
          Es obligación de todos los jugadores obedecer las indicaciones del
          Marshall.
        </li>

        <li>Es aconsejable que todos los jugadores jueguen “Ready Golf”.</li>
      </ol>
      <h2>5. RESPONSABILIDAD EN EL CUIDADO DEL CAMPO</h2>
      <p>
        Todos los socios e invitados son responsables del cuidado del campo.
      </p>

      <p>Es obligatorio:</p>

      <ul>
        <li>
          Arreglar los divots de las mesas de salida y del campo rellenándolos
          con arena especial.{" "}
        </li>
        <li>Rastrillar las trampas. </li>
        <li>Arreglar los divots del green con un arreglador de divots.</li>
        <br />
      </ul>
      <h2>6. SANCIONES</h2>

      <p>
        Cualquier jugador que sea reportado por no cuidar adecuadamente el campo
        recibirá una amonestación.
      </p>

      <h2>7. USO DE CARRITOS DE GOLF</h2>

      <p>
        El uso de carrito de Golf está permitido aplican las mismas reglas del
        reglamento general de golf.
      </p>

      <h2>CONSEJO DE ADMINISTRACIÓN</h2>

      <p>
        <b>PRESIDENTE</b> Arturo Zárate Rocha
      </p>

      <p>
        <b>COMITÉ DE GOLF</b> María Amparo Díaz Lozano Álvaro Huerta González
      </p>

      <p>
        <b>CAPITANA COMITÉ FEMENIL</b> Marisa Méndez Acosta
      </p>

      <p>
        <b>COMITÉ DE HÁNDICAPS</b> Ana Gloria Chávez De Flores Parkman Víctor
        Montalvo Castellanos
      </p>

      <p>
        <b>COMITÉ DE REGLAMENTO</b> Pablo Suinaga Cárdenas Héctor González Graf
        Alejandro Jorge Eduardo Orvañanos Alatorre Álvaro Huerta González María
        Amparo Díaz Lozano
      </p>

      <p>
        <b>COMITÉ LEGAL</b> Luis Gerardo Blanco Del Villar
      </p>

      <p>Ciudad de México, noviembre 2025</p>
    </div>
  );
};

export default GolfCourseAgreement;
